export default __webpack_public_path__ + "static/media/pokemonWhite-Logo.0deed5d9.png";